export default {
  getList: {
    method: 'post',
    url: '/vehicle/remooc/list'
  },
  getById: {
    method: 'get',
    url: '/vehicle/remooc/ID'
  },
  add: {
    method: 'post',
    url: '/vehicle/remooc'
  },
  delete: {
    method: 'delete',
    url: '/vehicle/remooc'
  },
  archive: {
    method: 'delete',
    url: '/vehicle/remooc/archive'
  },
  restore: {
    method: 'put',
    url: '/vehicle/remooc/restore'
  },
  edit: {
    method: 'put',
    url: '/vehicle/remooc/id'
  },
  find: {
    method: 'get',
    url: '/vehicle/remooc/find?key=KEY'
  },
  archiveDocument: {
    method: 'delete',
    url: '/vehicle/remooc-document/archive'
  },
  restoreDocument: {
    method: 'put',
    url: '/vehicle/remooc-document/restore'
  }
}
